// extracted by mini-css-extract-plugin
export default {"heading-wrapper":"styles_heading-wrapper__-Bfcf","button-wrapper":"styles_button-wrapper__PDqJW"};